export const kingaMrowka = {
    'meta': {
        'title': 'Psychoterapeuta w trakcie szkolenia, psychodietetyk Kinga Mrówka',
        'description': 'Jestem psychoterapeutką Gestalt w trakcie szkolenia oraz psychodietetyczką. W swojej pracy łączę podejście psychoterapeutyczne z wiedzą z zakresu dietetyki i zdrowego stylu życia.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psychoterapeuta-psychodietetyk-kinga-mrowka/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/kinga-mrowka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychoterapeuta w trakcie szkolenia, psychodietetyk Kinga Mrówka'
        }
    }
}